export default __webpack_public_path__ + "static/portfolio-22-78f4f5a2f3342f2ad658c2dc1ee7f557.jpg";